module.exports = __webpack_public_path__ + "img/canada-goose.ebc22423.jpg";